import { intl } from '@fullstory/intl';
import { SortOrder, SortType } from '@fullstory/proto/fs/api/metrics';
import { assertExhaustive } from '@fullstory/typeutils';

export const orderAndTypeToLabelMap = (
  sortType: SortType,
  aggregationLabel?: string,
): { [key in SortOrder.SORT_ORDER_ASC | SortOrder.SORT_ORDER_DESC]: string } => {
  switch (sortType) {
    case SortType.SORT_TYPE_AGGREGATION:
      return {
        [SortOrder.SORT_ORDER_ASC]: intl.formatMessage(
          {
            defaultMessage: '{aggregationLabel}: low to high',
            id: 'nWEikV',
          },
          { aggregationLabel },
        ),
        [SortOrder.SORT_ORDER_DESC]: intl.formatMessage(
          {
            defaultMessage: '{aggregationLabel}: high to low',
            id: 'A+q989',
          },
          { aggregationLabel },
        ),
      };
    case SortType.SORT_TYPE_ABSOLUTE_CHANGE:
      return {
        [SortOrder.SORT_ORDER_ASC]: intl.formatMessage({
          defaultMessage: 'Largest decrease: # change',
          id: '27JOFI',
        }),
        [SortOrder.SORT_ORDER_DESC]: intl.formatMessage({
          defaultMessage: 'Largest increase: # change',
          id: 'ZNV4xE',
        }),
      };
    case SortType.SORT_TYPE_RELATIVE_CHANGE:
      return {
        [SortOrder.SORT_ORDER_ASC]: intl.formatMessage({
          defaultMessage: 'Largest decrease: % change',
          id: 'ij/jkQ',
        }),
        [SortOrder.SORT_ORDER_DESC]: intl.formatMessage({
          defaultMessage: 'Largest increase: % change',
          id: 'Wt1TPx',
        }),
      };
    case SortType.SORT_TYPE_COUNT:
      return {
        [SortOrder.SORT_ORDER_ASC]: intl.formatMessage({
          defaultMessage: 'Lowest count',
          id: '8TBUuP',
        }),
        [SortOrder.SORT_ORDER_DESC]: intl.formatMessage({
          defaultMessage: 'Highest count',
          id: 'QUWAgP',
        }),
      };
    case SortType.SORT_TYPE_INVALID:
      return {
        [SortOrder.SORT_ORDER_ASC]: '',
        [SortOrder.SORT_ORDER_DESC]: '',
      };
    default:
      assertExhaustive(sortType);
  }
};
